(function ($, document, window) {
	'use strict';

	$(function () {
		const hideDescCards = document.querySelectorAll('.js-hide-desc-card');

		function getBgCardContentHeight(card) {
			const content = card.querySelector('.js-hide-desc-card-content');

			if (!content) {
				return '100%';
			}

			const contentHeight = content.offsetHeight;
			return `${contentHeight / 16}rem`;
		}

		hideDescCards.forEach((hideDescCard) => {
			hideDescCard.style.setProperty('--card-translate-y', getBgCardContentHeight(hideDescCard));

			const resizeObserver = new ResizeObserver(() => {
				hideDescCard.style.setProperty('--card-translate-y', getBgCardContentHeight(hideDescCard));
			});

			resizeObserver.observe(hideDescCard);
		});
	});
})(jQuery, document, window);
